import { Box, Divider, Flex, Text } from '@chakra-ui/react';
import { EventDirection } from 'model/modules/events/eventCategory';
import AppCard from 'presentation/components/shared/card/AppCard';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  directions: EventDirection[];
}

const EventDetailDirections: FC<Props> = ({ directions }) => {
  const { t } = useTranslation();

  const gap = 20;

  return (
    <>
      <GridHeading>{t('eventInvestmentsDirections')}</GridHeading>
      <AppCard
        px="20px"
        py="5px"
        display="flex"
        flexWrap="wrap"
        justifyContent="space-between"
      >
        {directions.map((direction, index) => (
          <Box key={index} w={`calc(50% - ${gap / 2}px)`}>
            {index > 1 && <Divider />}
            <Flex justifyContent="space-between" alignItems="center" py="10px">
              <Text mr="5px">{direction.name}</Text>
              <Text fontWeight={700}>{direction.value}</Text>
            </Flex>
          </Box>
        ))}
      </AppCard>
    </>
  );
};

export default EventDetailDirections;
